/**
 * NOTE: Move to masterDateSlice.ts
 */

import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {IEndUserParams} from '../../api/modules/master-data/types'
import {RootState} from '../../store'

interface IEndUserState {
  filter: IEndUserParams
}

const initialState: IEndUserState = {
  filter: {
    end_user_code: '',
    customer_name: '',
    customer_code: '',
    name: '',
    address: '',
    phone: '',
    email: '',
    province_name: '',
    city_name: '',
    business_field: '',
    segment_code: '',
    segment_name: '',
    status: '',
    per_page: 25,
  },
}

export const endUserSlice = createSlice({
  name: 'endUser',
  initialState,
  reducers: {
    setFilter(state: IEndUserState, action: PayloadAction<IEndUserParams>) {
      state.filter = action.payload
    },
    resetFilterEndUser(state: IEndUserState) {
      state.filter = initialState.filter
    },
  },
})

export const {setFilter, resetFilterEndUser} = endUserSlice.actions

export const endUserSelector = (state: RootState) => state.endUserReducer

export default endUserSlice.reducer
